<template>
    <div>
        <p v-text="$options.consentInfo" class="pb-3 mb-3 border-bottom" />
        <p v-text="$options.consentPurpose" class="mb-3" />
        <ui-checkbox-input
            class="mb-3"
            name="drs-consents-all"
            label="Zaznacz wszystkie"
            :value="allConsentsSelected"
            @change="setAllConsents"
        />
        <div v-for="consent in consentOptions" :key="consent.key" class="py-2">
            <ui-checkbox-input
                :name="`drs-${consent.key}`"
                :label="consent.label"
                :value="!!consents?.[consent.key]"
                @change="setConsentValue(consent.key, $event)"
            />

            <the-input
                v-if="consent.contactValue"
                readonly
                class="consent-contact mt-2 ml-4"
                :text="consent.contactValue"
            />
        </div>
    </div>
</template>

<script>
import { UiCheckboxInput } from '@/components/global/ui'

const CONSENT_OPTIONS = [
    {
        key: 'consent1',
        label: 'za pośrednictwem poczty elektronicznej na adres mailowy',
        contactField: 'email'
    },
    {
        key: 'consent2',
        label: 'za pośrednictwem połączeń telefonicznych na numer telefonu'
    },
    {
        key: 'consent3',
        label: 'za pośrednictwem SMS lub MMS na numer telefonu',
        contactField: 'phone'
    }
]

export default {
    consentInfo: 'Wyrażając poniższe zgody, umożliwiasz nam informowanie Cię o najnowszych ofertach i promocjach. Zgoda ta jest wymagana przez obowiązujące przepisy, w tym ustawę Prawo Komunikacji Elektronicznej. Pamiętaj, że w każdej chwili możesz zmienić swoją decyzję i wycofać zgodę, korzystając z odpowiedniej opcji. Wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem.',
    consentPurpose: 'Wyrażam zgodę na kontakt przez COMP S.A. w celu przekazania informacji o najnowszych promocjach, ofertach, konkursach oraz innych akcjach związanych z produktami oferowanymi lub nowo wprowadzanymi do oferty COMP S.A.',
    components: { UiCheckboxInput },

    props: {
        consents: {
            type: Object,
            default: null
        }
    },

    computed: {
        consentOptions() {
            return CONSENT_OPTIONS.map(consent => {
                const contactValue = this.$store.getters['drs/userData']?.[consent.contactField]
                const formattedContactValue = contactValue &&
                    consent.contactField === 'phone'
                    ? this.$options.filters.formatPhone(contactValue)
                    : contactValue

                return {
                    ...consent,
                    contactValue: formattedContactValue
                }
            })
        },

        allConsentsSelected() {
            return CONSENT_OPTIONS.every(({ key }) => this.consents?.[key])
        }
    },

    methods: {
        setAllConsents(value) {
            const consents = CONSENT_OPTIONS.reduce((result, { key }) => ({
                ...result,
                [key]: value
            }), {})

            this.$emit('change', consents)
        },

        setConsentValue(key, value) {
            this.$emit('change', {
                ...(this.consents || {}),
                [key]: value
            })
        }
    }
}
</script>

<style lang="scss">
.consent-contact {
    width: 20rem;
    max-width: calc(100% - 1.5rem);
}
</style>
